export async function getMediaPermissions() {
  return navigator.mediaDevices
    .getUserMedia({ audio: true, video: true })
    .then(() => {
      console.log('Доступ до мікрофона та камери надано');
      navigator.mediaDevices.enumerateDevices().then(devices => {
        console.log('Список пристроїв:', devices);
      });
    })
    .catch(error => {
      console.error('Помилка доступу до пристроїв:', error);
    });
}
